<template>
	<section>
		<header class="mb-4">
			<h1 class="text--text mr-5" style="opacity: 0.8; font-size: 35px">
				Produção
			</h1>
		</header>
		<LoaderDialog v-if="loading"/>
		<template v-if="!loading">
			<Detail v-if="boxToProduce"
				:status="getCurrentStatus"
				:subscriptionId="boxToProduce.subscriptionId"
				:patientName="boxToProduce.patient.name"
				:globalTags="boxToProduce.patient.globalTags"
				:surplusStock="boxToProduce.stockLeft"
				@startBoxProduction="startBoxProduction(boxToProduce.id)"
				@finishBoxProduction="observation => finishBoxProduction(boxToProduce.id, observation)" />
			<Choice v-else @search="getBoxToProduce" />
		</template>
	</section>
</template>

<script>
import { BoxPresenter } from '@Presenter/box-presenter';
import LoaderDialog from '@Views/componentes/loader-dialog.vue';
import { boxStatusBoxMap } from '@Consts/status-box';
import { boxProductionStatusMap } from '@Mixins/box-production';
import Choice from './choice';
import Detail from './detail';

export default {
	name: 'InProduction',
	components: {
		Choice,
		Detail,
		LoaderDialog
	},
	data() {
		return {
			loading: false,
			boxToProduce: null
		};
	},
	async created() {
		await this.getBoxInProduction();
	},
	methods: {
		async getBoxInProduction() {
			this.loading = true;
			try {
				const getCurrentBoxInProduceResponse = await BoxPresenter.getCurrentBoxInProduce();
				this.boxToProduce = getCurrentBoxInProduceResponse;
			} catch (error) {
				return this.$store.dispatch('SHOW_SNACKBAR', {
					message: 'Erro buscar Box para produção',
					color: 'error'
				});
			} finally {
				this.loading = false;
			}
		},
		async getBoxToProduce(identifier) {
			this.loading = true;
			try {
				const boxToProduceResponse = await BoxPresenter.getBoxToProduce(identifier);
				this.boxToProduce = boxToProduceResponse;
			} catch (error) {
				return this.$store.dispatch('SHOW_SNACKBAR', {
					message: error.message,
					color: 'error'
				});
			} finally {
				this.loading = false;
			}
		},
		async startBoxProduction(identifier) {
			this.loading = true;
			try {
				const boxStartProduceResponse = await BoxPresenter.startBoxProduction(identifier);
				this.boxToProduce.status = boxStartProduceResponse.status;
			} catch (error) {
				return this.$store.dispatch('SHOW_SNACKBAR', {
					message: 'Erro ao iniciar produção da Box',
					color: 'error'
				});
			} finally {
				this.loading = false;
			}
		},
		async finishBoxProduction(identifier, observation) {
			this.loading = true;
			try {
				const finishBoxToProduceResponse = await BoxPresenter.finishBoxProduction(identifier, observation);
				this.boxToProduce.status = finishBoxToProduceResponse.status;
			} catch (error) {
				return this.$store.dispatch('SHOW_SNACKBAR', {
					message: 'Erro ao finalizar produção da Box',
					color: 'error'
				});
			} finally {
				this.loading = false;
			}
		}
	},
	computed: {
		getCurrentStatus() {
			if (this.boxToProduce.status === boxStatusBoxMap.BILLED)
				return boxProductionStatusMap.WAITING;
			if (this.boxToProduce.status === boxStatusBoxMap.IN_PRODUCTION)
				return boxProductionStatusMap.IN_PROGRESS;
			return boxProductionStatusMap.FINISHED;
		}
	}
};
</script>

<style lang="scss" scoped>
header {
	border-bottom-width: 5px;
	border-bottom-color: #ffd9a0 !important;
	border-bottom-style: solid;
	padding-bottom: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
